<template>
  <div>
    <carousel
      id="customCarousel"
      ref="customCarousel"
      :autoplay="false"
      :loop="true"
      :per-page="1"
      :autoplayTimeout="10000"
      paginationPosition="top-overlay"
      paginationActiveColor="#8DB452"
      class="custom-carousel"
    >
      <slide v-if="verifyCurrently">
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
              />
              <span class="custom-color-text ml-2">
                <strong> {{ $t('common_words.climate') }} </strong>
              </span>
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-7">
              <span class="custom-color-text custom-font-size">
                {{ $t('common_words.actual_condition') }}
              </span>
            </div>
            <div class="col-12 col-sm-5 px-0">
              <el-select
                filterable
                class="select-default mb-3 ml-3 shadow-sm"
                :placeholder="`${$t('common_words.select2')}...`"
                v-model="idStation"
                @change="getDataClimateForecast(idStation)"
              >
                <el-option
                  class="select-default"
                  :label="$t('common_words.actual_position')"
                  :value="0"
                >
                </el-option>
                <el-option
                  class="select-default"
                  v-for="(station, index) in stations"
                  :key="index"
                  :label="station.name"
                  :value="station.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xl-7">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        {{ currentDate }}
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <span
                        class="first custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        <strong>
                          {{ day }}
                        </strong>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text custom-title-size"
                      >
                        <img
                          style="width: 50px"
                          src="/static/img/iconos/temperatura-white.svg"
                        />
                        {{
                          roundNumber(currently.currently.temperature, 1)
                        }}&deg;C
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <img
                        class="my-0 py-0"
                        style="width: 75px"
                        :src="`/static/img/iconos/${currently.currently.icon}-white.svg`"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        {{ $t('climate.temperature') }}
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="currently.currently.summary"
                      >
                        <span
                          class="custom-color-text my-0 py-0 custom-prop-text"
                          style="font-size: 20px"
                        >
                          {{ truncateText(currently.currently.summary) }}
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-5">
              <div
                class="row"
                v-if="currently.currently && Object.keys(currently).length > 0"
              >
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/humedad-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(currently.currently.humidity * 100, 2)
                    }}%</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.humidity') }} </strong>
                  </span>
                </div>
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/rain-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(currently.currently.precipIntensity, 2)
                    }}
                    mm/h</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.precipitation') }} </strong>
                  </span>
                </div>
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/lluvia-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(
                        currently.currently.precipProbability * 100,
                        2
                      )
                    }}%</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.rain_probability') }} </strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr style="background-color: white" />
          <div
            class="row mt-4 text-nowrap overflow-auto"
            v-if="currently.currently && Object.keys(currently).length > 0"
          >
            <div class="col-12">
              <el-row :gutter="24">
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.wind')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-avatar
                          fit="fill"
                          :size="60"
                          src="/static/img/iconos/viento-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <span class="custom-text-cards text-white">
                          {{
                            roundNumber(currently.currently.windSpeed * 3.6, 2)
                          }}
                          Km/h
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.pressure')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-avatar
                          fit="fill"
                          :size="60"
                          src="/static/img/iconos/barometro-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <span class="custom-text-cards">
                          {{ currently.currently.pressure }} mb
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.dew_point')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-avatar
                          fit="fill"
                          :size="60"
                          src="/static/img/iconos/rocio-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <span class="custom-text-cards">
                          {{ currently.currently.dewPoint }} &deg;C
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.cloud')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-avatar
                          fit="fill"
                          :size="60"
                          src="/static/img/iconos/cloudy-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <span class="custom-text-cards">
                          {{
                            roundNumber(
                              currently.currently.cloudCover * 100,
                              2
                            )
                          }}%
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.visibility')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <el-avatar
                          fit="fill"
                          :size="60"
                          src="/static/img/iconos/niebla-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <span class="custom-text-cards">
                          {{ roundNumber(currently.currently.visibility, 2) }}Km
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="4" :xl="4">
                  <el-row class="custom-row">
                    <el-col>
                      <div
                        class="grid-content bg-purple text-white text-center"
                      >
                        <span class="custom-text1">{{
                          $t('climate.ozone')
                        }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-avatar
                          fit="fill"
                          :size="61"
                          src="/static/img/iconos/ozono-white.svg"
                        ></el-avatar>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center mt-1">
                        <span class="custom-text-cards">
                          {{ currently.currently.ozone }}U.D.
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </card>
      </slide>
      <slide v-if="verifyDaily">
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
              />
              <span class="custom-color-text ml-2">
                <strong> {{ $t('common_words.climate') }} </strong>
              </span>
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <span class="custom-color-text custom-font-size">
                {{ $t('climate.forecast_six_days') }}
              </span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-xl-7">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        {{ tomorrowDate }}
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <span
                        class="first custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        <strong>
                          {{ currently.fullWeek[1] }}
                        </strong>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text custom-title-size"
                      >
                        <img
                          style="width: 50px"
                          src="/static/img/iconos/temperatura-white.svg"
                        />
                        {{
                          roundNumber(
                            currently.daily.data[1].temperatureMax,
                            1
                          )
                        }}&deg;C
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <img
                        class="my-0 py-0"
                        style="width: 75px"
                        :src="`/static/img/iconos/${currently.daily.data[1].icon}-white.svg`"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 my-0 py-0">
                      <span
                        class="custom-color-text my-0 py-0 custom-prop-text"
                        style="font-size: 20px"
                      >
                        {{ $t('climate.temperature') }}
                      </span>
                    </div>
                    <div class="col-6 my-0 py-0 px-0 mx-0 text-center">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="currently.daily.data[1].summary"
                      >
                        <span
                          class="custom-color-text my-0 py-0 custom-prop-text"
                          style="font-size: 20px"
                        >
                          {{ truncateText(currently.daily.data[1].summary) }}
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-5">
              <div
                class="row"
                v-if="currently.currently && Object.keys(currently).length > 1"
              >
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/humedad-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(currently.daily.data[1].humidity * 100, 2)
                    }}%</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.humidity') }} </strong>
                  </span>
                </div>
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/rain-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(currently.daily.data[1].precipIntensity, 2)
                    }}
                    mm/h</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.precipitation') }} </strong>
                  </span>
                </div>
                <div class="col-12 icon-climate-actually">
                  <img alt="" src="/static/img/iconos/lluvia-white.svg" />
                  <span class="custom-text custom-color-text"
                    >{{
                      roundNumber(
                        currently.daily.data[1].precipProbability * 100,
                        2
                      )
                    }}%</span
                  >
                  <span class="custom-text custom-color-text">
                    <strong> {{ $t('climate.rain_probability') }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr style="background-color: white" />
          <div class="row">
            <div class="col-12">
              <el-row>
                <el-col
                  v-for="(day, index) in dayCards"
                  :key="index"
                  :xs="8"
                  :sm="8"
                  :md="8"
                  :lg="4"
                  :xl="4"
                >
                  <el-row class="custom-row">
                    <el-col>
                      <div class="text-white text-center">
                        <span class="custom-text-cards ml-2">{{ day }}</span>
                      </div>
                    </el-col>
                    <el-col>
                      <div class="text-center">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="currently.daily.data[index + 2].summary"
                        >
                          <el-avatar
                            fit="fill"
                            :size="60"
                            :src="`/static/img/iconos/${
                              currently.daily.data[index + 2].icon
                            }-white.svg`"
                          >
                          </el-avatar>
                        </el-tooltip>
                      </div>
                    </el-col>
                    <el-col>
                      <div
                        class="d-flex flex-row justify-content-center text-center"
                      >
                        <el-avatar
                          fit="fill"
                          :size="22"
                          src="/static/img/iconos/temperatura-white.svg"
                        ></el-avatar>
                        <span class="custom-text-cards mt-1 text-white">
                          {{
                            roundNumber(
                              currently.daily.data[index + 2].temperatureMax,
                              1
                            )
                          }}&deg;C
                        </span>
                      </div>
                    </el-col>
                    <el-col>
                      <div
                        class="d-flex flex-row justify-content-center mt-2 mr-2 text-center"
                      >
                        <el-avatar
                          fit="fill"
                          :size="22"
                          src="/static/img/iconos/lluvia-white.svg"
                        ></el-avatar>
                        <span class="custom-text-cards mt-1 text-white">
                          {{
                            roundNumber(
                              currently.daily.data[index + 2]
                                .precipProbability * 100,
                              2
                            )
                          }}%
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </card>
      </slide>
      <slide v-else>
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
              />
              <span class="custom-color-text ml-2">
                <strong> {{ $t('common_words.climate') }} </strong>
              </span>
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-7">
              <span class="custom-color-text custom-font-size">
                {{ $t('common_words.actual_condition') }}
              </span>
            </div>
            <div class="col-12 col-sm-5 px-0">
              <el-select
                filterable
                class="select-default mb-3 ml-3 shadow-sm"
                :placeholder="`${$t('common_words.select2')}...`"
                v-model="idStation"
              >
                <el-option
                  class="select-default"
                  :label="$t('common_words.actual_position')"
                  :value="0"
                >
                </el-option>
                <el-option
                  class="select-default"
                  v-for="(station, index) in stations"
                  :key="index"
                  :label="station.name"
                  :value="station.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </card>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { Avatar, Card, Col, Row, Tooltip } from 'element-ui';
import Vue from 'vue';
import VueCarousel, { Carousel, Slide } from 'vue-carousel';
import moment from 'moment';
import MixinNumbers from 'src/util/mixinNumbers';
import mixinLocation from 'src/util/mixinLocation';
import SweetAlert from 'src/class/Alerts';
import axios from 'axios';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

Vue.use(VueCarousel);

export default {
  name: 'ClimateCarousel',
  components: {
    [Avatar.name]: Avatar,
    [Card.name]: Card,
    [Col.name]: Col,
    [Row.name]: Row,
    [Tooltip.name]: Tooltip,
    Carousel,
    Slide,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      idStation: null,
      stations: [],
      rangeSlider: null,
      currently: [],
      currentDate: moment().format('DD/MM/YYYY'),
      currentTime: moment().format('hh:mm:ss'),
      currentYear: moment().format('YYYY'),
      tomorrowDate: moment().add(1, 'days').format('DD/MM/YYYY'),
    };
  },
  mixins: [MixinNumbers, mixinLocation],
  computed: {
    currentDateCalendar() {
      return moment().locale(i18n.locale).format('LLLL');
    },

    currentDay() {
      return moment().locale(i18n.locale).format('dddd');
    },

    day() {
      return this.currentDay.charAt(0).toUpperCase() + this.currentDay.slice(1);
    },
    dayCards() {
      return this.currently.fullWeek.slice(2, 8);
    },
    verifyCurrently() {
      return this.currently.currently && Object.keys(this.currently).length > 0;
    },
    verifyDaily() {
      return this.currently.daily && Object.keys(this.currently).length > 0;
    },
  },
  methods: {
    handleRange(min, max) {
      this.rangeSlider = [min, max];
    },

    truncateText(text) {
      if (text.length > 18) {
        return text.substring(0, 18) + '...';
      }
      return text;
    },

    setDataClimateForecast(idStation) {
      const baseUrl = 'weatherkitappleapi/getDataApi';
      const url =
        idStation === 0
          ? `${baseUrl}/${this.center.lat},${this.center.lng}`
          : `${baseUrl}/${idStation}`;

      Axios.getMasters(url)
        .then((response) => {
          this.currently = response.data.data;
          if (idStation !== 0) {
            this.center.lat = this.currently.latitude
              ? parseInt(this.currently.latitude)
              : this.center.lat;
            this.center.lng = this.currently.longitude
              ? parseInt(this.currently.longitude)
              : this.center.lng;
          }
          this.handleRange(
            this.currently.daily.data[0].temperatureMin,
            this.currently.daily.data[0].temperatureMax
          );
          this.climate = true;
          this.showClimate = true;
        })
        .catch((error) => {
          console.log(error);
          this.climate = true;
          this.showClimate = true;
        });
    },

    async getDataClimateForecast(idStation) {
      if (Object.keys(this.center).length === 0) {
        await this.getPosition();
      }

      this.idStation = idStation;
      this.setDataClimateForecast(idStation);
    },

    async getStations() {
      const response = await axios.get('auth/devices/stations/only/all');
      if (response.data) {
        this.stations = response.data.data;
        if (this.stations.length > 0) {
          await this.getDataClimateForecast(
            0,
            i18n.t('common_words.actual_pos')
          );
        } else {
          SweetAlert.warning(i18n.t('common_words.unavailable_stations'));
        }
      } else {
        SweetAlert.warning(error.response.data.message);
      }
    },
  },
  async created() {
    await this.getStations();
  },
};
</script>
<style scoped>
.first::first-letter {
  text-transform: capitalize !important;
}
.custom-card-bg-color {
  background-color: #33653b !important;
}
.custom-color-text {
  color: white !important;
}
.custom-text {
  font-size: 20px !important;
}
.custom-text1 {
  font-size: 12px !important;
  margin-left: 10px;
}
.custom-text-cards {
  font-size: 11px !important;
  color: white !important;
}
.icon-climate-actually {
  padding-top: 5px;
}
.custom-prop-text {
  font-family: 'Open Sans', sans-serif;
}
.custom-font-size {
  font-size: 20px;
}
.custom-title-size {
  font-size: 40px;
}
.el-avatar {
  background: none;
}
</style>
